import { Alert } from 'app/models/dto/alert.model';
import { ContactRelationship } from 'app/models/dto/contact-relationship.model';
import { Contact } from 'app/models/dto/contact.model';
import { ErcContact } from 'app/models/dto/erc-contact.model';

export class GetContactsForBorrower {
	static readonly type = '[Contact] GetContactsForBorrower';
	constructor(public borrowerId: number, public refresh?: boolean) {}
}

export class DeleteContact {
  static readonly type = '[Contact] DeleteContact';
  constructor(public contactId: number) {}
}

export class UnsetPrimaryContact {
  static readonly type = '[Contact] UnsetPrimaryContact';
  constructor(public setPrimaryContact: Contact) {}
}

export class SetPrimaryContact {
  static readonly type = '[Contact] SetPrimaryContact';
  constructor(public setPrimaryContact: Contact) {}
}

export class ToggleSaving {
  static readonly type = '[Contact] ToggleSaving';
  constructor(public contactId: number) {}
}

export class SetNewContact {
  static readonly type = '[Contact] SetNewContact';
  constructor() {}
}

export class UnsetNewContact {
  static readonly type = '[Contact] UnsetNewContact';
  constructor() {}
}

export class CreateContact {
  static readonly type = '[Contact] CreateContact';
  constructor(public newContact: any) {}
}

export class UpdateContact {
  static readonly type = '[Contact] UpdateContact';
  constructor(public contact: Contact) {}
}

export class CreateContactAlert {
  static readonly type = '[Contact] CreateContactAlert';
  constructor(public alert: Alert) { }
}

export class DismissContactAlert {
  static readonly type = '[Contact] DismissContactAlert';
  constructor(public alert: Alert) { }
}

export class SendSignatureRequest {
  static readonly type = '[Contact] SendSignatureRequest';
  constructor(public contact: Contact) {}
}

export class ClearContactStore {
	static readonly type = '[Contact] ClearContactStore';
	constructor() {}
}

export class GetContactOwnerRelationships {
  static readonly type = '[Contact] GetContactOwnerRelationships';
  constructor(public borrowerId: number) {}
}

export class GetContactEmployeeRelationships {
  static readonly type = '[Contact] GetContactEmployeeRelationships';
  constructor(public borrowerId: number) {}
}

export class GetErcContacts{
  static readonly type = '[Contact] GetErcContacts';
  constructor(public borrowerId: number) {}
}

export class CreateContactOwnerRelationship {
  static readonly type = '[Contact] CreateContactOwnerRelationship';
  constructor(public contactOwnerRelationship: ContactRelationship, public borrowerId: number) {}
}

export class CreateContactEmployeeRelationship {
  static readonly type = '[Contact] CreateContactEmployeeRelationship';
  constructor(public contactEmployeeRelationship: ContactRelationship, public borrowerId: number) {}
}

export class CreateErcContact {
  static readonly type = '[Contact] CreateErcContact';
  constructor(public borrowerId: number) {}
}

export class UpdateErcContact {
  static readonly type = '[Contact] UpdateErcContact';
  constructor(public ercContact: ErcContact) {}
}

export class UpdateContactEmployeeRelationship {
  static readonly type = '[Contact] UpdateContactEmployeeRelationship';
  constructor(public contactEmployeeRelationship: ContactRelationship) {}
}

export class UpdateContactOwnerRelationship {
  static readonly type = '[Contact] UpdateContactRelationship';
  constructor(public contactOwnerRelationship: ContactRelationship) {}
}

export class DeleteContactRelationship {
  static readonly type = '[Contact] DeleteContactRelationship';
  constructor(public contactRelationship: ContactRelationship, public key: string) {}
}



